module.exports = __webpack_public_path__ + "static/Travelers-5a2efe33e50e7c6cbf647ba21f8f58b8.jpg";